import { FooterButton, type FooterDensity } from "../FooterButton";
import { FOOTER_ROW_GAP_CLASS } from "./useFooterDensity";
import type { FooterBarItem } from "./footerPinning";

// Степените, които се мерят; squeeze не се мери — там всичко се свива заедно.
const MEASURED_DENSITIES: FooterDensity[] = ["normal", "compact", "tight"];

interface FooterMeasureRowProps {
  ref: React.Ref<HTMLDivElement>;
  items: FooterBarItem[];
}

/**
 * Невидимите редове за `useFooterDensity`: целият ред на лентата във всяка
 * степен на свиване — така се знае коя се събира, преди да е показана.
 * Нулев размер и `invisible`, за да не мести нищо и да не се натиска;
 * ширините на редовете се мерят нормално.
 */
export const FooterMeasureRow = ({ ref, items }: FooterMeasureRowProps) => (
  <div
    ref={ref}
    aria-hidden
    className="pointer-events-none invisible absolute left-0 top-0 h-0 w-0 overflow-hidden"
  >
    {MEASURED_DENSITIES.map((density) => (
      <div
        key={density}
        data-density={density}
        className={`flex w-max items-center ${FOOTER_ROW_GAP_CLASS[density]}`}
      >
        {items.map((item) => (
          <FooterButton
            key={item.key}
            {...item.button}
            lockedTooltip={undefined}
            density={density}
            measureOnly
          />
        ))}
      </div>
    ))}
  </div>
);
